import {
  RealtimeMessageEvents,
  RealtimeEvents,
} from 'modules/Socket/realtimeEvents'

import handleAssignmentEvent from './handleAssignmentEvent'
import handleMessageEvents from './handleMessageEvents'

const realtimeHandler = (params) => {
  const { eventName } = params
  if (Object.values(RealtimeMessageEvents).includes(eventName)) {
    return handleMessageEvents(params)
  } else if (eventName === RealtimeEvents.chatAssignment) {
    return handleAssignmentEvent(params)
  }
}

export default realtimeHandler
